import { render, staticRenderFns } from "./NecessaryDocumentsModal.vue?vue&type=template&id=5a417056&scoped=true&"
import script from "./NecessaryDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./NecessaryDocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./NecessaryDocumentsModal.vue?vue&type=style&index=0&id=5a417056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a417056",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CAccordionIcon: require('@chakra-ui/vue').CAccordionIcon, CAccordionHeader: require('@chakra-ui/vue').CAccordionHeader, CListItem: require('@chakra-ui/vue').CListItem, CFlex: require('@chakra-ui/vue').CFlex, CList: require('@chakra-ui/vue').CList, CAccordionPanel: require('@chakra-ui/vue').CAccordionPanel, CDivider: require('@chakra-ui/vue').CDivider, CAccordionItem: require('@chakra-ui/vue').CAccordionItem, CAccordion: require('@chakra-ui/vue').CAccordion})
